import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';

export const makeActionList = (params: any) => {
	const { hasPermission, appName } = params;
	return {
		rowActions: [
			{
				name: 'Edit',
				id: 'edit',
				isEnabled: () => {
					return hasPermission({
						entity: DASHBOARD_RESOURCES.mttSchema,
						actions: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.mttSchema].updateSchema,
						appName,
						configPageName: PAGE_NAMES.dashboard
					});
				}
			},
			{
				name: 'Delete',
				id: 'delete',
				isEnabled: () => {
					return hasPermission({
						entity: DASHBOARD_RESOURCES.mttSchema,
						actions: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.mttSchema].deleteSchema,
						appName,
						configPageName: PAGE_NAMES.dashboard
					});
				}
			}
		],
		addAction: {
			name: 'Add',
			id: 'add',
			isEnabled: () => {
				return hasPermission({
					entity: DASHBOARD_RESOURCES.mttSchema,
					actions: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.mttSchema].createSchema,
					appName,
					configPageName: PAGE_NAMES.dashboard
				});
			}
		},
		uploadAction: {
			name: 'Upload CSV',
			id: 'uploadCsv',
			isEnabled: () => {
				return hasPermission({
					entity: DASHBOARD_RESOURCES.mttSchema,
					actions: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.mttSchema].uploadCsv,
					appName,
					configPageName: PAGE_NAMES.dashboard
				});
			}
		}
	};
};

export default {
	makeActionList
};
